import { AnimatedChunk, StyledTypingText } from "./styles";
import type { TypingTextProps } from "./useTypingAnimation";
import { useTypingAnimation } from "./useTypingAnimation";

export const TypingText = (props: TypingTextProps) => {
    const chunks = useTypingAnimation(props);

    return (
        <StyledTypingText>
            {chunks.map((chunk, index) => (
                <AnimatedChunk key={index}>{chunk}</AnimatedChunk>
            ))}
        </StyledTypingText>
    );
};
